<template>
  <div class="home">
    <commonHead :data="parentData"></commonHead>
    <div class="home-top-img">
      <el-carousel height="1000px" class="banners" trigger="click" arrow="never" >
        <el-carousel-item v-for="item in 4" :key="item">
          <el-image class="banners-img" :src="item === 1 ? banner1 : item === 2 ? banner2 : item === 3 ? banner3 : banner4" fit="cover"></el-image>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="product-content">
      <el-row class="home-row" :gutter="30">
          <el-col class="home-col" :span="12">
            <el-row class="home-col-boxs">
              <el-col :span="2"></el-col>
              <el-col class="home-col-box" :span="10">
                <div class="home-col-title">{{ $t('home.hhb_title') }}</div>
                <div class="home-col-desc">{{ $t('home.hhb_desc1') }}</div>
                <div class="home-col-desc">{{ $t('home.hhb_desc2') }}</div>
                <el-button @click="gotoHhb()" class="home-button" round>{{ $t('home.more') }}</el-button>
              </el-col>
              <el-col :span="12" class="product-col2">
                <el-image class="product-img" :src="h1"></el-image>
              </el-col>
            </el-row>
          </el-col>
          <el-col class="home-col" :span="12">
            <el-row class="home-col-boxs">
              <el-col :span="2"></el-col>
              <el-col class="home-col-box" :span="10">
                <div class="home-col-title" v-html="$t('home.breeze1_title')"></div>
                <div class="home-col-desc" v-html="$t('home.breeze1_desc1')"></div>
                <div class="home-col-desc">{{ $t('home.breeze1_desc2') }}</div>
                <el-button @click="gotoBreeze('one')" class="home-button" round>{{ $t('home.more') }}</el-button>
              </el-col>
              <el-col :span="12" class="product-col2">
                <el-image class="product-img" :src="c1"></el-image>
              </el-col>
            </el-row>
          </el-col>
          <el-col class="home-col" :span="12">
            <el-row class="home-col-boxs">
              <el-col :span="2"></el-col>
              <el-col class="home-col-box" :span="10">
                <div class="home-col-title" v-html="$t('home.breeze2_title')"></div>
                <div class="home-col-desc">{{ $t('home.breeze2_desc1') }}</div>
                <div class="home-col-desc">{{ $t('home.breeze2_desc2') }}</div>
                <el-button @click="gotoBreeze('two')" class="home-button" round>{{ $t('home.more') }}</el-button>
              </el-col>
              <el-col :span="12" class="product-col2">
                <el-image class="product-img" :src="c2"></el-image>
              </el-col>
            </el-row>
          </el-col>
          <el-col class="home-col" :span="12">
            <el-row class="home-col-boxs">
              <el-col :span="2"></el-col>
              <el-col class="home-col-box" :span="10">
                <div class="home-col-title" v-html="$t('home.breeze3_title')"></div>
                <div class="home-col-desc">{{ $t('home.breeze3_desc1') }}</div>
                <div class="home-col-desc">{{ $t('home.breeze3_desc2') }}</div>
                <el-button @click="gotoBreeze('three')" class="home-button" round>{{ $t('home.more') }}</el-button>
              </el-col>
              <el-col :span="12" class="product-col2">
                <el-image class="product-img" :src="c3"></el-image>
              </el-col>
            </el-row>
          </el-col>
          
        </el-row>
        <!-- <el-row class="product-row1" :gutter="30">
          <el-col :span="12">
            <el-image class="product-img" :src="productSrc3"></el-image>
          </el-col>
          <el-col :span="12">
            <el-image class="product-img" :src="productSrc4"></el-image>
          </el-col>
        </el-row> -->
    </div>
    <div class="home-content">
      <div class="home-content-box">
        <div class="home-content-title">{{ $t('home.content_title') }}</div>
        <div class="home-content-desc">
          <p>{{ $t('home.content_desc[0]') }}</p>
          <p>{{ $t('home.content_desc[1]') }}</p>
          <p>{{ $t('home.content_desc[2]') }}</p>
        </div>
      </div>
      <el-row class="home-content-bottom" :gutter="40">
        <el-col :span="12">
          <video class="home-content-bottom-img home-content-bottom-img1" :poster="video1Png" src="../assets/image/video1.mp4" controls></video>
            
        </el-col>
        <el-col :span="12">
          <video class="home-content-bottom-img" :poster="video2Png" src="../assets/image/video2.mp4" controls></video>
        </el-col>
      </el-row>
    </div>
    <div class="home-bottom-box">
      <div class="home-bottom-box-mengban">
        <div class="home-bottom-box-mengban-title">
          <p class="title">{{ $t('home.bottom_title') }}</p>
          <p class="en">{{ $t('home.bottom_en') }}</p>
        </div>
      </div>
      <WaterfallGallery 
        :images="imageList"
        :columnCount="3"
        :columnGap="15"
        @loadmore="handleLoadMore"
        @item-click="handleImageClick"
      />
    </div>
    <!-- <div class="footer">
      <p class="footer-title">LIFSONG</p>
      <p class="footer-email">lifsong365@gmail.com</p>
    </div> -->
    <commonFooter></commonFooter>
  </div>
</template>

<script lang="ts" setup>
import commonHead from '@/components/commonHeader.vue'
import commonFooter from '@/components/commonFooter.vue'
import WaterfallGallery from '@/components/waterfallGallery.vue'
import homeSrc from '@/assets/image/c1.webp';
import banner1 from '@/assets/image/home/banner1.webp';
import banner2 from '@/assets/image/home/banner2.webp';
import banner3 from '@/assets/image/home/banner3.webp';
import banner4 from '@/assets/image/home/banner4.webp';
import c1 from '@/assets/image/home/h3.webp';
import c2 from '@/assets/image/home/h1.webp';
import c3 from '@/assets/image/home/h4.webp';
import h1 from '@/assets/image/home/h2.webp';

import productSrc from '@/assets/image/c1.webp';
import productSrc1 from '@/assets/image/c1.webp';
import productSrc2 from '@/assets/image/c2.webp';
import productSrc3 from '@/assets/image/c3.webp';
import productSrc4 from '@/assets/image/h1.webp';
import video1 from '@/assets/image/video1.mp4';
import video1Png from '@/assets/image/home/video1.webp';
import video2Png from '@/assets/image/home/video2.webp';
import video2 from '@/assets/image/video2.mp4';

import p1 from '@/assets/image/home/1.webp';
import p2 from '@/assets/image/home/2.webp';
import p3 from '@/assets/image/home/3.webp';
import p4 from '@/assets/image/home/banner1.webp';
import p5 from '@/assets/image/home/5.webp';
import p6 from '@/assets/image/home/6.webp';
import p7 from '@/assets/image/home/7.webp';
import p8 from '@/assets/image/home/banner2.webp';
import p9 from '@/assets/image/home/9.webp';
import p10 from '@/assets/image/home/10.webp';
import p11 from '@/assets/image/home/11.webp';
import p12 from '@/assets/image/home/banner3.webp';
import p13 from '@/assets/image/home/13.webp';
import p14 from '@/assets/image/home/14.webp';
import p15 from '@/assets/image/home/15.webp';
import p16 from '@/assets/image/home/banner4.webp';
import p17 from '@/assets/image/home/17.webp';
import p18 from '@/assets/image/home/18.webp';
import p19 from '@/assets/image/home/19.webp';
import p20 from '@/assets/image/home/20.webp';
import p21 from '@/assets/image/home/21.webp';
import p22 from '@/assets/image/home/22.webp';
import p23 from '@/assets/image/home/23.webp';
import p24 from '@/assets/image/home/24.webp';
import p25 from '@/assets/image/home/25.webp';



import { ref,onMounted } from 'vue';
import { useRouter } from 'vue-router';  // import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
const store = useStore();
const router = useRouter();

const parentData = '0';// 传递给父组件的数据
store.commit('setNavIndex',0)

const gotoHhb = () =>{
  router.push('/hhb')
}

const gotoBreeze = (value: any) =>{
  router.push({path:'/breeze',query:{name:value}})
}

const handleLoadMore = () => {
  console.log('load more');
}
const handleImageClick = (item:any) => {
  console.log('image click',item);
}


const imageList = ref([
  { image: p1, alt: 'Image 1' },
  { image: p2, alt: 'Image 2' },
  { image: p3, alt: 'Image 3' },
  { image: p4, alt: 'Image 4' },
  { image: p5, alt: 'Image 5' },
  { image: p6, alt: 'Image 5' },
  { image: p7, alt: 'Image 5' },
  { image: p8, alt: 'Image 5' },
  { image: p9, alt: 'Image 5' },
  { image: p10, alt: 'Image 5' },
  { image: p11, alt: 'Image 5' },
  { image: p12, alt: 'Image 5' },
  { image: p13, alt: 'Image 5' },
  { image: p14, alt: 'Image 5' },
  { image: p15, alt: 'Image 5' },
  { image: p16, alt: 'Image 5' },
  { image: p17, alt: 'Image 5' },
  { image: p18, alt: 'Image 5' },
  { image: p19, alt: 'Image 5' },
  { image: p20, alt: 'Image 5' },
  { image: p21, alt: 'Image 5' },
  { image: p22, alt: 'Image 5' },
  { image: p23, alt: 'Image 5' },
  { image: p24, alt: 'Image 5' },
  { image: p25, alt: 'Image 5' }
  ])
// this.$store.commit('setNavIndex', 1);
// console.log('HomeView loaded',this.$store.state.navIndex);
</script>

<style lang="scss" scoped>

.product-content{
  padding: 0 2em;
  margin-top: 2em;
  
  @media (max-width: 768px) {
    margin-top: 1em;
  }
  // .product-row1{
  //   margin-top: 2em;
  // }
  // .product-img{
  //   width: 100%;
  // }
  .home-col-boxs{
    background: #eee;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-content: center;
    flex-direction: row;
    margin-top: 20px;
    
    @media (max-width: 768px) {
      margin-top: 10px;
    }
    .home-col-box{
      border-radius: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      // padding-left: 80px;
      
      .home-col-title{
        font-size: 1.2em;
      }
      .home-col-desc{
        font-size: 1.2em;
        font-weight: 600;
        margin-top: .5em;
      }
      .home-button{
        width: min-content;
        margin: 2em auto 0;
        background: #000;
        color: #fff;

      }
    }
    .product-col2{
      display: flex;
      justify-content: flex-start;
      align-content: center;
    }
    .product-img{
      width: 80%;
    }
  }
}
.home-content{
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  .home-content-box{
    width: 100%;
    max-width: 1400px;
    height: auto;
    min-height: 480px;
    margin-top: 100px;
    background: #f4f4f4;

    @media (max-width: 768px) {
      margin-top: 50px;
      padding-bottom: 30px;
      height: auto;
    }
    .home-content-title{
      font-size: 2.5em;
      font-weight: bold;
      padding-top: 128px;
    }
    .home-content-desc{
      margin-top: 67px;
      font-size: 1.5em;
      p{
        margin: 12px 0;
      }
    }
  }
  .home-content-bottom{
    margin-top: 100px;
    width: 100%;
    max-width: 1440px;
    padding: 0 20px;
    box-sizing: border-box;
    .home-content-bottom-img{
      width: 100%;
      height: 300px;

      @media (max-width: 768px) {
        height: auto;
        margin-bottom: 20px;
      }
    }

    @media (max-width: 768px) {
       margin-top: 50px;
    }
  }
}
.home-bottom-box{
  margin-top: 100px;
  // .home-bottom-img{
  //   width: 100%;
  // }
  position: relative;
  background: #000;
  .home-bottom-box-mengban{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index:9;
    .home-bottom-box-mengban-title{
      font-size: 4.5em;
      font-weight: bold;
      color: #fff;
      .en{
        margin-top: 1em;
      }
    }
  }
}


.banners{
  // min-height: 1000px;
  .banners-img{
    width: 100%;
  }

  @media (max-width: 768px) {
    height: 500px !important;
    :deep(.el-carousel__container) {
      height: 500px !important;
    }
  }
}
</style>
